import React from 'react';
import Card from '../components/Card';
import Button from '../components/Button';

export default function Billing() {
  const invoices = [
    { month: 'Dec 2025', codes: 1100, amount: 550.00, status: 'paid', date: 'Dec 31' },
    { month: 'Nov 2025', codes: 950, amount: 475.00, status: 'paid', date: 'Nov 30' },
    { month: 'Oct 2025', codes: 1200, amount: 600.00, status: 'paid', date: 'Oct 31' },
  ];

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Billing</h1>
        <p className="page-subtitle">Manage your subscription and invoices</p>
      </div>

      <Card title="Current Subscription">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px', padding: '20px 0' }}>
          <div>
            <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              Plan
            </div>
            <div style={{ fontSize: '18px', fontWeight: '600' }}>
              Pay-Per-Code
            </div>
          </div>

          <div>
            <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              Cost Per Code
            </div>
            <div style={{ fontSize: '18px', fontWeight: '600', color: 'var(--green)' }}>
              $0.50
            </div>
          </div>

          <div>
            <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              Status
            </div>
            <div style={{ fontSize: '18px', fontWeight: '600' }}>
              <span className="badge success">✅ Active</span>
            </div>
          </div>
        </div>

        <div style={{ marginTop: '16px', padding: '16px', background: 'var(--bg-tertiary)', borderRadius: '8px' }}>
          <div style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
            Next Billing Date
          </div>
          <div style={{ fontSize: '16px', fontWeight: '600', marginTop: '4px' }}>
            January 1, 2026
          </div>
        </div>
      </Card>

      <div style={{ marginTop: '24px' }}>
        <Card title="Payment Method">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 0' }}>
            <div>
              <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '4px' }}>
                Visa ending in 4242
              </div>
              <div style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>
                Expires 12/26
              </div>
            </div>
            <Button variant="secondary">Change Method</Button>
          </div>
        </Card>
      </div>

      <div style={{ marginTop: '24px' }}>
        <Card 
          title="Recent Invoices" 
          subtitle="Your billing history"
          actions={<Button variant="secondary">View All</Button>}
        >
          <div className="table-container" style={{ marginTop: '20px' }}>
            <table className="table">
              <thead>
                <tr>
                  <th>Month</th>
                  <th>Codes Purchased</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Invoice</th>
                </tr>
              </thead>
              <tbody>
                {invoices.map((invoice, index) => (
                  <tr key={index}>
                    <td>{invoice.month}</td>
                    <td>{invoice.codes.toLocaleString()}</td>
                    <td style={{ fontWeight: '600', color: 'var(--green)' }}>
                      ${invoice.amount.toFixed(2)}
                    </td>
                    <td>
                      <span className="badge success">✅ Paid</span>
                    </td>
                    <td>{invoice.date}</td>
                    <td>
                      <button className="btn btn-secondary" style={{ padding: '6px 12px', fontSize: '12px' }}>
                        📄 PDF
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </div>
  );
}
